<template>
  <main>
    <nav v-if='kql.page' class='main'>
      <header>
        <FilterNavigation v-model="filter" v-slot="{ setActiveFilter, activeFilter }">
          <button value="" @click="setActiveFilter('')" :class="{ active: activeFilter === '' }">All</button>
          <button value="Conductor" @click="setActiveFilter('Conductor')" :class="{ active: activeFilter === 'Conductor' }">Conductor</button>
          <button value="Composer" @click="setActiveFilter('Composer')" :class="{ active: activeFilter === 'Composer' }">Composer</button>
        </FilterNavigation>
        <h2 class='title' v-html='kql.page?.content?.title' />
      </header>
      <template v-if='events' v-for='(item, index) in eventsWithYearDividers' :key='item.id || `year-${item.year}`'>
        <h2 v-if='item.isYearDivider' class='year-divider'>{{ item.year }}</h2>
        <EventCard v-else :event='item' />
      </template>
      <p v-if='futureEvents?.length === 0' class='no-results'>No upcoming events found.</p>
    </nav>
    <MainFooter/>
  </main>
</template>
<script setup>
  //import fragmentShader from "@/components/glsl/stars.frag"
  import { useStore } from '@/KQL.js'
  import { clamp, filterItems, pageFromPath, clampObjectArray, filterPublicPages } from '@/utils';
  import Events from '@/components/Sections/Events.vue'
  import FilterNavigation from '@/components/Navigation/FilterNavigation.vue'
  import { useRoute, useRouter } from 'vue-router'

  const kql = useStore()
  const route = useRoute()
  const router = useRouter()

  // Initialize filter from URL query parameter
  const filter = ref(route.query.filter || '');

  // Watch for filter changes and update URL
  watch(filter, (newFilter) => {
    router.replace({
      query: { ...route.query, filter: newFilter || undefined }
    })
  })

  const max = 100;
  const events = computed(() => filterPublicPages(pageFromPath('calendar', kql?.pages)?.children));
  const today = new Date().toISOString().split('T')[0];
  const filteredEvents = computed(() => filterItems(events.value, event => filter.value ? event.content.type.includes(filter.value) : true ));
  const futureEvents = computed(() => filterItems(filteredEvents.value, event => event.content.date >= today ));

  // Insert year dividers when year changes between events
  const eventsWithYearDividers = computed(() => {
    const eventsList = clampObjectArray(futureEvents.value, max);
    if (!eventsList || eventsList.length === 0) return [];

    const result = [];
    let previousYear = null;

    eventsList.forEach((event, index) => {
      const eventYear = new Date(event.content.date).getFullYear();

      // Don't add year divider before the first event
      if (index > 0 && previousYear !== null && eventYear !== previousYear) {
        result.push({
          isYearDivider: true,
          year: eventYear
        });
      }

      result.push(event);
      previousYear = eventYear;
    });

    return result;
  });
</script>

<style>
  body {
    background-color: black;
  }
</style>

<style scoped>
@import '@/css/breakpoints.css';

  h2.title {
    position: relative;
    top: -2.66rem;
  }

  nav.main {
    background-color: black;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(30rem, 1fr));
    gap: minmax(10px, 2vw);
    margin: auto;
    padding-top: 30rem;
    width: var(--main-width-narrow);
  }

  nav.main header {
    padding-bottom: 6rem;
  }

  @media (--phone) {
    nav.main {
      padding-top: 25rem;
      justify-content: center;
    }
  }

  .no-results {
    grid-column: 1 / -1;
    text-align: center;
    opacity: 0.6;
    font-style: italic;
  }

  h2.year-divider {
    grid-column: 1 / -1;
    margin: 6rem 0 3rem 0;
  }

</style>
